export { default as PainelIris } from './PainelIris';
export { default as LinhaConfig } from './LinhaConfig';
export { default as ToggleIris } from './ToggleIris';
export { default as AbasSublinhado } from './AbasSublinhado';
export type { AbaSublinhado } from './AbasSublinhado';
export { default as BadgeEmBreve } from './BadgeEmBreve';

/** Input Íris (mock: h-9, fundo surface-2, borda --border-strong, raio 7px;
    foco = borda accent + glow 3px accent-soft + fundo surface). */
export const inputIris =
  'h-9 px-3 text-sm bg-surface-2 border border-line-strong rounded-iris-sm text-tx placeholder:text-tx-3 focus:outline-none focus:bg-surface focus:border-accent focus:ring-[3px] focus:ring-accent-soft disabled:opacity-50 disabled:cursor-not-allowed';

/** Botões Íris (classes utilitárias compartilhadas). */
export const btnPrimario =
  'inline-flex items-center justify-center gap-1.5 h-9 px-4 text-sm font-semibold rounded-iris bg-accent text-white hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed';
export const btnSecundario =
  'inline-flex items-center justify-center gap-1.5 h-9 px-4 text-sm font-semibold rounded-iris bg-surface-2 border border-line text-tx hover:bg-surface transition-colors disabled:opacity-50 disabled:cursor-not-allowed';
export const btnDanger =
  'inline-flex items-center justify-center gap-1.5 h-9 px-4 text-sm font-semibold rounded-iris bg-danger text-white hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed';
